import { render, staticRenderFns } from "./profile-screen.vue?vue&type=template&id=b45559e8&"
import script from "./profile-screen.vue?vue&type=script&lang=js&"
export * from "./profile-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b45559e8')) {
      api.createRecord('b45559e8', component.options)
    } else {
      api.reload('b45559e8', component.options)
    }
    module.hot.accept("./profile-screen.vue?vue&type=template&id=b45559e8&", function () {
      api.rerender('b45559e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/profile-screen.vue"
export default component.exports